export const defaultSuggesterConfig = {
    azureSearch: {
        url: '',
        key: ''
    },
    searchParams: {
        search: '*',
        highlightPreTag: '<strong class="tps-autocomplete-search-highlight">',
        highlightPostTag: '</strong>',
        suggesterName: null,
        fuzzy: false,
        searchFields: null,
        select: '*',
        top: null,
        filter: null,
        orderby: 'search.score() desc'
    },
    suggestions: {
        listBoxAriaLabel: null,
        minLength: 1,
        onSelect: null,
    },
    onResults: function () { },
    debug: false
};
